import type { CSSProperties } from "react";

const cellPadding = "4px 6px";

export const payoutBreakdownStyles = {
  popoverSurface: {
    maxWidth: 440,
    padding: 12,
  } satisfies CSSProperties,

  title: {
    fontWeight: 600,
    marginBottom: 8,
  } satisfies CSSProperties,

  spinnerRow: {
    padding: 16,
    display: "flex",
    justifyContent: "center",
  } satisfies CSSProperties,

  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 12,
  } satisfies CSSProperties,

  th: {
    textAlign: "left",
    padding: cellPadding,
  } satisfies CSSProperties,

  td: {
    padding: cellPadding,
    verticalAlign: "top",
  } satisfies CSSProperties,

  rowPositive: {
    color: "green",
  } satisfies CSSProperties,

  rowNegative: {
    color: "red",
  } satisfies CSSProperties,
} as const;
